module.exports = __webpack_public_path__ + "static/video_poster_01.572f9aaf.png";